class NestedFields {
  constructor() {
    this.bindEvents()
  }

  bindEvents() {
    this.updateRemoveButtons()

    document.addEventListener('cocoon:after-insert', () => {
      this.updateRemoveButtons()
    })
    document.addEventListener('cocoon:after-remove', () => {
      this.updateRemoveButtons()
    })
  }

  updateRemoveButtons() {
    document.querySelectorAll('.nested-fields').forEach((field, index) => {
      const removeButton = field.querySelector('.remove-fields')
      if (removeButton) {
        if (index === 0 || index === 1) {
          removeButton.style.display = 'none'
        } else {
          removeButton.style.display = ''
        }
      }
    })
  }
}

export default NestedFields
